/* eslint-disable no-restricted-syntax */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable no-unreachable */
import { Button, ColorPicker, Dropdown, Form, Input } from "antd";
import { isEmpty } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import DownIcon from "../../../icons/DownIcon";
import {
  CenterAlignedIcon,
  LeftAlignedIcon,
  RightAlignedIcon,
} from "../../../icons/js/EditorIcons/AlignmentIcons";
import BoldIcon from "../../../icons/js/EditorIcons/BoldIcon";
import ImageIcon from "../../../icons/js/EditorIcons/ImageIcon";
import ItalicIcon from "../../../icons/js/EditorIcons/ItalicIcon";
import OrderedListIcon from "../../../icons/js/EditorIcons/OrderedListIcon";
import UnderlineIcon, { StrikeThroughIcon } from "../../../icons/js/EditorIcons/UnderlineIcon";
import UnorderedListIcon from "../../../icons/js/EditorIcons/UnorderedListIcon";
import { AiStarsIcon } from "../../../icons/js/EmailAiIcons";
import LinkIcon from "../../../icons/js/LinkIcon";
import { AudioRecorder } from "./AudioRecorder";
import { AiPopoverForEmail } from "./EmailAiComponents";
import {
  EDITOR_COMMANDS,
  EDITOR_FONT_SIZE_LABELS,
  EDITOR_FONT_SIZE_PIXELS,
  EDITOR_FONT_SIZES,
  EDITOR_IMAGE_ID_PREFIX,
  EDITOR_LINK_ID_PREFIX,
  ZERO_WIDTH_SPACE,
} from "../../../constant/EmailConstant";
import "./richTextEditor.css";

const RichTextEditorWithAudioRecorder = ({
  setcontent,
  setAudioUrl,
  audioUrl,
  audioBlob,
  setaudioBlob,
  mode,
  leadNote,
  allowRecording = true,
  toolBarPosition = "top",
  editorHeight = "",
  editorCustomClassName = "",
  controllerClassName = "",
  textDisabled = false,
  FOBJSX = null,
  propRef = null,
  onSelect = () => {},
  getSelectionRange = () => {},
  showAttachImages = true,
  showColorPicker = false,
  showAiPopup = true,
  selectedText,
}) => {
  const [fontSize, setFontSize] = useState(EDITOR_FONT_SIZES.NORMAL);
  const [popoverPosition, setPopoverPosition] = useState({ x: 0, y: 0 });
  const [isLinkModalVisible, setIsLinkModalVisible] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [refState, setrefState] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [showGeneratePopover, setshowGeneratePopover] = useState({
    open: false,
    type: "",
    component: null,
  });
  const [savedSelection, setSavedSelection] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Enhanced selection management
  const saveSelection = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      // Make sure the selection is within our editor
      if (refState && refState.contains(range.commonAncestorContainer)) {
        setSavedSelection(range.cloneRange());
        return range;
      }
    }
    return null;
  };

  const restoreSelection = () => {
    if (savedSelection) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(savedSelection);
      return true;
    }
    return false;
  };

  const [aiDropdownOpen, setaiDropdownOpen] = useState(false);
  const close = () =>
    setshowGeneratePopover({
      open: false,
      type: "",
      component: null,
    });
  const editorRef = useRef(null);
  const imageDropdownRef = useRef(null);
  const LinkDropdownRef = useRef(null);
  const fileRef = useRef(null);

  const handleChange = () => {
    setcontent(refState.innerHTML);
  };

  // Improved style application with better selection handling
  const applyStyle = (command, value = null) => {
    refState.focus();

    // Restore selection first
    if (!restoreSelection()) {
      // If no selection to restore, get current selection
      const selection = window.getSelection();
      if (selection.rangeCount === 0) return;
    }

    // For font size, use CSS styling instead of deprecated font tags
    if (command === EDITOR_COMMANDS.FONT_SIZE) {
      const selection = window.getSelection();
      const range = selection.getRangeAt(0);

      const pixelSize =
        EDITOR_FONT_SIZE_PIXELS[value] || EDITOR_FONT_SIZE_PIXELS[EDITOR_FONT_SIZES.NORMAL];

      // If selection is collapsed (just cursor), insert a styled span
      if (range.collapsed) {
        document.execCommand(EDITOR_COMMANDS.STYLE_WITH_CSS, false, true);
        const span = document.createElement("span");
        span.style.fontSize = pixelSize;
        span.textContent = ZERO_WIDTH_SPACE; // Zero-width space
        range.insertNode(span);

        // Move cursor to end of inserted span
        range.setStartAfter(span);
        range.setEndAfter(span);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        // For non-collapsed selection
        document.execCommand(EDITOR_COMMANDS.STYLE_WITH_CSS, false, true);

        // Create a temporary span and apply the font size to it
        const span = document.createElement("span");
        span.style.fontSize = pixelSize;

        // Extract content and place inside the span
        span.appendChild(range.extractContents());
        range.insertNode(span);

        // Update selection to include the new span
        range.selectNodeContents(span);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    } else if (command === EDITOR_COMMANDS.CREATE_LINK && value) {
      // Handle link creation
      document.execCommand(command, false, value);
      // Find all links with this URL and set target="_blank"
      const links = refState.querySelectorAll(`a[href="${value}"]`);
      links.forEach(link => {
        link.target = "_blank";
        link.rel = "noopener noreferrer";
      });
    } else if ([EDITOR_COMMANDS.ORDERED_LIST, EDITOR_COMMANDS.UNORDERED_LIST].includes(command)) {
      // Improve list handling
      document.execCommand(EDITOR_COMMANDS.STYLE_WITH_CSS, false, false);
      document.execCommand(command, false, value);

      // Add proper styling to the newly created list
      const lists = refState.querySelectorAll(
        command === EDITOR_COMMANDS.ORDERED_LIST ? "ol" : "ul"
      );
      lists.forEach(list => {
        list.style.paddingLeft = "20px";
        list.style.margin = "8px 0";
      });
    } else {
      // Execute the command normally for other formatting
      document.execCommand(command, false, value);
    }

    // Focus back to editor and save the new selection
    refState.focus();
    saveSelection();
    handleChange();
  };

  useEffect(() => {
    setrefState(propRef?.current || editorRef.current);
  }, [propRef, editorRef]);

  const handleCursorPosition = () => {
    saveSelection();

    const selection = window.getSelection();

    // Check if there's a valid selection
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    const rect = range.getBoundingClientRect();
    const editor = (propRef || editorRef)?.current;

    let cursorPosition = 0;

    if (editor) {
      const preCaretRange = range.cloneRange();
      preCaretRange.selectNodeContents(editor);
      preCaretRange.setEnd(range.endContainer, range.endOffset);

      // Calculate the cursor position without altering the original HTML
      const tempDiv = document.createElement("div");
      tempDiv.appendChild(preCaretRange.cloneContents());
      cursorPosition = tempDiv.innerHTML.length;
    }

    // Create a minimal selection object with only needed properties
    const selectionObj = {
      startContainer: range.startContainer,
      startOffset: range.startOffset,
      element: range.startContainer.parentElement,
      cursorPosition, // Add the calculated cursor position
      savedRange: range,
    };

    // Batch state updates
    requestAnimationFrame(() => {
      setCursorPosition(selectionObj);
      getSelectionRange(selectionObj);
      onSelect(selection.toString());
      setPopoverPosition({ x: rect.left + rect.width / 2, y: rect.top });
    });
  };

  const [selection, setSelection] = useState(null);

  const closeSelection = () => {
    setSelection(null);
    close();
    setaiDropdownOpen(false);
  };

  const handleSelection = () => {
    saveSelection();

    const selectedText = window.getSelection().toString();
    if (selectedText) {
      const range = window.getSelection().getRangeAt(0);
      const selectionRect = range.getBoundingClientRect();
      const divRect = (propRef || editorRef)?.current?.getBoundingClientRect();

      setSelection({
        text: selectedText,
        top: selectionRect.bottom - divRect.top,
        left: selectionRect.right - divRect.left,
        startRange: range.startOffset,
        endRange: range.endOffset,
      });
    } else {
      setSelection(null);
      close();
      setaiDropdownOpen(false);
    }
  };

  const insertLink = (command, url) => {
    // Restore selection first
    restoreSelection();

    // Insert the link or HTML
    document.execCommand(command, false, url);
    refState.focus();
    saveSelection();
    handleChange();
  };

  const handleFontSize = size => {
    setFontSize(size);
    applyStyle(EDITOR_COMMANDS.FONT_SIZE, size);
  };

  const handleBold = () => {
    applyStyle(EDITOR_COMMANDS.BOLD);
  };

  const handleLinkOk = (url, title) => {
    restoreSelection();
    const id = `${EDITOR_LINK_ID_PREFIX}${Math.random()}`;
    // Make sure the URL starts with http:// or https:// for proper link functionality
    const formattedUrl =
      url.startsWith("http://") || url.startsWith("https://") ? url : `https://${url}`;
    const link = `<a href="${formattedUrl}" target="_blank" rel="noopener noreferrer" id="${id}">${
      title || url
    }</a>`;
    insertLink(EDITOR_COMMANDS.INSERT_HTML, link);
  };

  const handleLinkCancel = () => {
    setLinkUrl("");
    setIsLinkModalVisible(false);
  };

  const handleImageOk = url => {
    restoreSelection();
    const id = `${EDITOR_IMAGE_ID_PREFIX}${Math.random()}`;
    const img = `<img height="150px" width="150px" src="${url}" id="${id}" />`;
    insertLink(EDITOR_COMMANDS.INSERT_HTML, img);
  };

  const handleImageDropdownClick = key => {
    switch (key) {
      case "uploadFromComputer":
        fileRef.current.click();
        break;
      default:
        break;
    }
  };

  // Prevent default behavior on dropdown trigger to avoid losing selection
  const handleMouseDown = e => {
    e.preventDefault();
    saveSelection();
  };

  // Handle dropdown open/close
  const handleDropdownVisibleChange = visible => {
    if (visible && !dropdownOpen) {
      saveSelection();
    }
    setDropdownOpen(visible);
  };

  const HorizontalLine = () => <div className="h-10 w-[1px] bg-grey-200" />;

  const controlItems = [
    {
      render: (
        <Dropdown
          trigger="click"
          menu={{
            items: [
              {
                label: EDITOR_FONT_SIZE_LABELS[EDITOR_FONT_SIZES.SMALL],
                key: EDITOR_FONT_SIZES.SMALL,
              },
              {
                label: EDITOR_FONT_SIZE_LABELS[EDITOR_FONT_SIZES.NORMAL],
                key: EDITOR_FONT_SIZES.NORMAL,
              },
              {
                label: EDITOR_FONT_SIZE_LABELS[EDITOR_FONT_SIZES.LARGE],
                key: EDITOR_FONT_SIZES.LARGE,
              },
              {
                label: EDITOR_FONT_SIZE_LABELS[EDITOR_FONT_SIZES.HUGE],
                key: EDITOR_FONT_SIZES.HUGE,
              },
            ],
            onClick: info => handleFontSize(info.key),
          }}
          onOpenChange={handleDropdownVisibleChange}
        >
          <span
            onMouseDown={handleMouseDown}
            className="flex-row-centered text-xs text-grey-700 gap-1 cursor-pointer"
          >
            {EDITOR_FONT_SIZE_LABELS[fontSize] || EDITOR_FONT_SIZE_LABELS[EDITOR_FONT_SIZES.NORMAL]}
            <DownIcon />
          </span>
        </Dropdown>
      ),
      hover: false,
    },
    {
      render: <HorizontalLine />,
      hover: false,
    },
    ...(showColorPicker
      ? [
          {
            render: (
              <ColorPicker
                size="small"
                className="rounded-full"
                defaultValue="black"
                onChange={(value, hex) => applyStyle("foreColor", hex)}
              />
            ),
            hover: false,
          },
        ]
      : []),
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            handleBold();
          }}
        >
          <BoldIcon />
        </span>
      ),
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.ITALIC);
          }}
        >
          <ItalicIcon />
        </span>
      ),
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.UNDERLINE);
          }}
        >
          <UnderlineIcon />
        </span>
      ),
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.STRIKETHROUGH);
          }}
        >
          <StrikeThroughIcon />
        </span>
      ),
    },
    {
      render: <HorizontalLine />,
      hover: false,
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.JUSTIFY_LEFT);
          }}
        >
          <LeftAlignedIcon />
        </span>
      ),
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.JUSTIFY_CENTER);
          }}
        >
          <CenterAlignedIcon />
        </span>
      ),
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.JUSTIFY_RIGHT);
          }}
        >
          <RightAlignedIcon />
        </span>
      ),
    },
    {
      render: <HorizontalLine />,
      hover: false,
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.ORDERED_LIST);
          }}
        >
          <OrderedListIcon />
        </span>
      ),
    },
    {
      render: (
        <span
          className="controls"
          onMouseDown={e => {
            e.preventDefault();
            applyStyle(EDITOR_COMMANDS.UNORDERED_LIST);
          }}
        >
          <UnorderedListIcon />
        </span>
      ),
    },
    {
      render: <HorizontalLine />,
      hover: false,
    },
    {
      render: (
        <Dropdown
          trigger="click"
          menu={{
            items: [
              {
                label: (
                  <LinkForm
                    dropdownRef={LinkDropdownRef}
                    handleOk={handleLinkOk}
                    editorRef={editorRef}
                    refState={refState}
                    type="Link"
                  />
                ),
              },
            ],
          }}
        >
          <span
            className="controls"
            onMouseDown={e => {
              e.preventDefault();
            }}
            ref={LinkDropdownRef}
          >
            <LinkIcon />
          </span>
        </Dropdown>
      ),
    },
    ...(showAttachImages
      ? [
          {
            render: (
              <Dropdown
                trigger="click"
                menu={{
                  items: [
                    {
                      label: "Upload from computer",
                      key: "uploadFromComputer",
                    },
                    {
                      label: (
                        <LinkForm
                          dropdownRef={imageDropdownRef}
                          handleOk={handleImageOk}
                          editorRef={editorRef}
                          refState={refState}
                          type="Image"
                        />
                      ),
                    },
                  ],
                  onClick: e => handleImageDropdownClick(e.key),
                }}
              >
                <span
                  className="controls"
                  onMouseDown={e => {
                    e.preventDefault();
                    refState.focus();
                  }}
                  ref={imageDropdownRef}
                >
                  <ImageIcon />
                </span>
              </Dropdown>
            ),
          },
        ]
      : []),
  ];

  useEffect(() => {
    if (mode === "EDIT" && refState) {
      refState.innerHTML = leadNote.note;
    }
  }, [mode, leadNote, refState]);

  const handleFileUpload = files => {
    if (showAttachImages) {
      files.forEach(file => {
        if (file.type.includes("image")) {
          // TODO: This is base64 version of the code to insert images
          const reader = new FileReader();
          reader.onload = e => {
            const base64String = e.target.result;
            handleImageOk(base64String);
          };
          reader.readAsDataURL(file);
        }
      });
    }
  };

  function replaceTextInHTML(replacementText) {
    try {
      // First restore any saved selection
      restoreSelection();

      const selection = window.getSelection();
      if (!selection || selection.rangeCount === 0) {
        return;
      }

      const range = selection.getRangeAt(0);

      // Check if range is valid before proceeding
      if (!range) {
        return;
      }

      try {
        // Delete the current selection content first
        range.deleteContents();

        // Insert the new content as HTML
        const fragment = document.createDocumentFragment();
        const tempDiv = document.createElement("div");

        // Ensure replacementText is a string
        tempDiv.innerHTML =
          typeof replacementText === "string" ? replacementText : String(replacementText || "");

        // Safely move the contents of the temporary div into the fragment
        while (tempDiv.firstChild) {
          fragment.appendChild(tempDiv.firstChild);
        }

        // If fragment is empty, add a space to maintain cursor position
        if (!fragment.hasChildNodes()) {
          fragment.appendChild(document.createTextNode(" "));
        }

        // Insert the fragment at the position of the deleted content
        range.insertNode(fragment);

        // Clear selection and close the selection UI
        selection.removeAllRanges();
      } catch (insertError) {
        console.error("Error during content insertion:", insertError);
        // Fallback: try a simpler approach
        document.execCommand("insertHTML", false, replacementText);
      }

      // Always close selection UI and update content even if there were errors
      closeSelection();
      handleChange();
    } catch (error) {
      console.error("Error in replaceTextInHTML:", error);
      // Ultimate fallback - try to append content to editor if everything else fails
      try {
        if (refState) {
          const p = document.createElement("p");
          p.innerHTML = replacementText;
          refState.appendChild(p);
          handleChange();
        }
      } catch (fallbackError) {
        console.error("Even fallback failed:", fallbackError);
      }
    }
  }

  // Add event listener to handle link clicks
  useEffect(() => {
    if (refState) {
      // Function to handle link clicks
      const handleLinkClick = e => {
        const { target } = e;
        // Check if clicked element is a link
        if (target.tagName === "A") {
          e.preventDefault();

          // Get the href attribute
          const href = target.getAttribute("href");
          if (href) {
            // Open the link in a new tab
            window.open(href, "_blank", "noopener,noreferrer");
          }
        }
      };

      // Add event listener
      refState.addEventListener("click", handleLinkClick);

      // Clean up
      return () => {
        if (refState) {
          refState.removeEventListener("click", handleLinkClick);
        }
      };
    }
  }, [refState]);

  return (
    <div className="max-h-[56vh] overflow-auto">
      <div
        id="rich-text-controller"
        className="flex-row-centered px-2 bg-grey-100 rounded-tl-sm rounded-tr-sm gap-1 justify-between"
      >
        <input
          type="file"
          onChange={e => {
            refState.focus();
            handleFileUpload(Array.from(e.target.files));
          }}
          className="hidden"
          multiple
          accept="image/*"
          ref={fileRef}
        />
        {allowRecording && (
          <AudioRecorder
            audioBlob={audioBlob}
            setaudioBlob={setaudioBlob}
            setAudioUrl={setAudioUrl}
            audioUrl={audioUrl}
            editorRef={editorRef}
            setcontent={setcontent}
          />
        )}
        {toolBarPosition === "top" && (
          <div className="flex-row-centered gap-2 ">
            {controlItems.map((item, index) => {
              const hover = item.hover ?? true;
              return (
                <span key={index} className={`${hover ? "hover:bg-[#E2E8F0]" : ""} rounded-sm`}>
                  {item.render}
                </span>
              );
            })}
          </div>
        )}
      </div>
      <div className="relative">
        <Editor
          editorRef={editorRef}
          propRef={propRef}
          editorHeight={editorHeight}
          editorCustomClassName={editorCustomClassName}
          textDisabled={textDisabled}
          handleChange={handleChange}
          handleCursorPosition={handleCursorPosition}
          setIsDragging={value => {
            if (showAttachImages) {
              setIsDragging(value);
            }
          }}
          isDragging={isDragging}
          handleFileUpload={handleFileUpload}
          refState={refState}
          selectedText={selectedText}
          popoverPosition={popoverPosition}
          handleSelection={handleSelection}
          onKeyUp={() => {
            handleCursorPosition();
            saveSelection();
          }}
        />
        {!isEmpty(selection) && showAiPopup && (
          <div
            style={{
              position: "absolute",
              top: `${selection?.top}px`,
              left: `${selection?.left}px`,
              zIndex: 999,
            }}
          >
            <AiPopoverForEmail
              close={close}
              popoverPosition={popoverPosition}
              setshowGeneratePopover={setshowGeneratePopover}
              showGeneratePopover={showGeneratePopover}
              aiDropdownOpen={aiDropdownOpen}
              setaiDropdownOpen={setaiDropdownOpen}
              selection={selection}
              setselection={setSelection}
              replaceText={value => replaceTextInHTML(value)}
            >
              <div
                onClick={() => {
                  setaiDropdownOpen(true);
                  saveSelection();
                }}
                className="flex-row-centered cursor-pointer rounded-full p-2 bg-warning-100 border border-solid border-warning-500"
              >
                <AiStarsIcon color="#334155" />
              </div>
            </AiPopoverForEmail>
          </div>
        )}
      </div>
      {toolBarPosition === "bottom" && (
        <div
          id="rich-text-controller"
          className={`flex-row-centered sticky bottom-0 -mt-4 px-2 bg-grey-100 rounded-tl-sm rounded-tr-sm gap-1 justify-between ${controllerClassName}`}
        >
          <div className="flex-row-centered gap-2 ">
            {controlItems.map((item, index) => {
              const hover = item.hover ?? true;
              return (
                <span key={index} className={`${hover ? "hover:bg-[#E2E8F0]" : ""} rounded-sm`}>
                  {item.render}
                </span>
              );
            })}
          </div>
          <div>{FOBJSX}</div>
        </div>
      )}
      {isDragging && (
        <div className="absolute inset-0 bg-opacity-50 flex items-center justify-center border-[4px] border-dashed border-grey-300">
          <p className="text-xl font-bold text-blue-700">Drop your files here</p>
        </div>
      )}
    </div>
  );
};

export default RichTextEditorWithAudioRecorder;

function Editor({
  editorRef,
  propRef,
  editorHeight,
  textDisabled,
  handleChange,
  handleCursorPosition,
  setIsDragging,
  isDragging,
  handleFileUpload,
  refState,
  selectedText,
  popoverPosition,
  handleSelection,
  onKeyUp,
  editorCustomClassName,
}) {
  return (
    <div
      ref={propRef || editorRef}
      className={`focus-visible:outline-none overflow-y-auto ${editorHeight || "h-[57vh]"} mb-4 
      ${editorCustomClassName || "border border-solid py-2 px-5 border-grey-200"}`}
      contentEditable={!textDisabled}
      id="rich-text"
      onInput={handleChange}
      onSelect={handleCursorPosition}
      onMouseUp={handleSelection}
      onDragEnter={e => {
        e.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={e => {
        e.preventDefault();
        setIsDragging(false);
      }}
      onDragOver={e => {
        e.preventDefault();
        if (!isDragging) setIsDragging(true);
      }}
      onDrop={e => {
        e.preventDefault();
        setIsDragging(false);
        refState.focus();
        handleFileUpload(Array.from(e.dataTransfer.files));
      }}
      onKeyUp={onKeyUp}
    />
  );
}

function LinkForm({ handleOk, editorRef, dropdownRef, type, refState }) {
  const [form] = Form.useForm();
  return (
    <Form
      onFinish={value => {
        handleOk(value.url, value.title);
        dropdownRef.current.click();
        form.resetFields();
      }}
      form={form}
      onClick={e => {
        e.stopPropagation();
      }}
      layout="vertical"
      size="small"
    >
      {type !== "Image" && (
        <Form.Item
          rules={[{ whitespace: true, message: "Please enter a link title" }]}
          name="title"
          label="Add Title"
        >
          <Input name="title" />
        </Form.Item>
      )}
      <Form.Item
        rules={[
          { required: true, message: "Url is required", whitespace: true },
          { type: "url", message: "Please enter a valid Url" },
        ]}
        name="url"
        label="Add Url"
      >
        <Input name="url" />
      </Form.Item>
      <div className="flex-row-centered justify-end">
        <Button type="primary" htmlType="submit" onClick={() => refState.focus()}>
          Insert {type}
        </Button>
      </div>
    </Form>
  );
}
